<template>
  <svg
    width="14"
    height="14"
    fill="none"
    :class="['icon', 'icon_' + type]"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="circle"
      d="M13 7A6 6 0 111 7a6 6 0 0112 0z"
    />
    <rect
      class="dot"
      x="6.3"
      y="2.9"
      width="1.18"
      height="1.18"
      rx=".59"
    />
    <path
      class="mark"
      d="M6.89 5.162a.59.59 0 00-.59.59v4.916a.59.59 0 001.18 0V5.752a.59.59 0 00-.59-.59z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'warning'
    }
  }
}
</script>

<style lang="scss" scoped>
$colorInfo: #0A5CD7;
$colorWarning: #F87900;

.icon {
  &_warning {
    .circle {
      stroke: $colorWarning;
    }
    .mark {
      stroke: none;
      fill: $colorWarning;
    }
    .dot {
      stroke: none;
      fill: $colorWarning;
    }
  }
  &_info {
    .circle {
      stroke: $colorInfo;
    }
    .mark {
      stroke: none;
      fill: $colorInfo;
    }
    .dot {
      stroke: none;
      fill: $colorInfo;
    }
  }
}
</style>
